exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.icon-button_container_278u5 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    font-size: 0.75rem;\n    font-family: \"Poppins\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--looks-secondary);\n    border-radius: 10px;\n}\n\n.icon-button_container_278u5 + .icon-button_container_278u5 {\n    margin-top: 1.25rem;\n}\n\n.icon-button_title_36ChS {\n    margin-top: 0.5rem;\n    text-align: center;\n}\n\n.icon-button_disabled_2HD_J {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.icon-button_container_278u5:active {\n    background-color: var(--looks-light-transparent);\n}\n", ""]);

// exports
exports.locals = {
	"container": "icon-button_container_278u5",
	"title": "icon-button_title_36ChS",
	"disabled": "icon-button_disabled_2HD_J"
};